
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "c196daed7c700d34e592132f1428572b309ac2a6",
  "nuxt": {
    "buildId": "296502c1-278c-4f31-8cf1-5216b5c1c8ee"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
